import type { RouteRecordRaw } from 'vue-router'

const dashboardRoutes: RouteRecordRaw[] = [
  {
    path: 'dashboard',
    name: 'dashboard',
    component: () => import('@/views/dashboard/DashboardIndex.vue'),
    meta: {
      titleKey: 'routes.dashboard.title',
      icon: 'Odometer',
      helpKey: 'dashboard'
    }
  }
]

export default dashboardRoutes
